import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { UserManagerProvider } from '../user-manager/user-manager';
import { Util } from '../../util/Util';
import { AdBanner } from '../../model/AdBanner';

/*
  Generated class for the AdBannerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class AdBannerProvider {

  adBanners: Array<AdBanner> = new Array<AdBanner>();
  adBannerFreq: number = 10;

  constructor(public http: Http, private userManager: UserManagerProvider) {
    console.log('Hello AdBannerProvider Provider');
    this.refresh();
  }

  refresh() {
    return new Promise((resolve, reject) => {
      let lang = this.userManager.getLang();
      this.http.get(Util.getAdDiscussionBannerUrl(lang)).toPromise().then(response => {
        this.adBanners = new Array<AdBanner>();
        response.json().content.forEach(adBanner => {
          this.adBanners.push(new AdBanner(adBanner.small, adBanner.large, adBanner.action, adBanner.destination, adBanner.param));
        });
        // this.largeAdBanner = response.json().large;
        // this.bannerAction = response.json().action;
        this.adBannerFreq = parseInt(response.json().frequency);
        // console.log(this.smallAdBanner + ", " + this.adBannerFreq + ", " + this.adBanners);
        // console.log(this.adBanners);
        // if (response.json().param != null && response.json().param != "") {
        //   this.bannerActionParam = response.json().param;
        // }
        // this.bannerDestination = response.json().destination;
        resolve();
      }, err => {
        console.log(err);
        reject();
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/ad-banner/ad-banner.ts